import { render } from "./SinistroAcordoDetalheView.vue?vue&type=template&id=e834df08&scoped=true"
import script from "./SinistroAcordoDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroAcordoDetalheView.vue?vue&type=script&lang=js"

import "./SinistroAcordoDetalheView.vue?vue&type=style&index=0&id=e834df08&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e834df08"]])

export default __exports__